import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

/* import function from store folder */
import { resetModel } from '../../store/components/modelSlice';

const Notification = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const cancelHandler = () => dispatch(resetModel());

    const confirmation = () => {
        cancelHandler();
        navigate('/driver/list');
    };

    return (
        <Modal show={ true } onHide={ cancelHandler } centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div className="message-container">
                    <h2>完成通知</h2>
                </div>
                <div className="button-container">
                    <Button type="button" data-shadow onClick={ confirmation }>確定</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default Notification;